import { FreshStartOrigin } from "./FreshStartOriginConfig";

export enum AuthFlowType {
  PHONE_LOGIN = 'phone-login',
  EMAIL_LOGIN = 'email-login',
}

export enum FlowType {
  AUTH = 'auth',
  ASSOCIATION = 'association'
}

export enum AuthStepType {
  VALIDATE_PASSWORD = 'validate-password',
  SET_PASSWORD = 'set-password',
  VERIFY_OTP = 'verify-otp',
  RECOVER_PIN = 'recover-pin',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  MFA_VALIDATION = 'mfa-validation'
}

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  type: FlowType,
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    nextButton: string;
    input: {
      text: string;
      aria: string;
    }
  }
  identifierField: 'email' | 'phoneNumber';
  showFreshStart?: boolean;
  freshStartOrigin?: FreshStartOrigin;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.PHONE_LOGIN]: {
    form: "verify_PIN__" + AuthFlowType.PHONE_LOGIN,
    flow: AuthFlowType.PHONE_LOGIN,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "email_login_phonenumber_association_pin.header_title",
      headerSubtitle: "email_login_phonenumber_association_pin.header_message",
      nextButton: 'email_login_phonenumber_association_pin.button_next_message',
      input: {
        text: "email_login_phonenumber_association_pin.pin_input",
        aria: "accessibility.email.login.validate_pin_phonenumber_association"
      }
    },
    identifierField: 'phoneNumber',
    showFreshStart: true,
    freshStartOrigin: FreshStartOrigin.PHONE_LOGIN_PIN,
  },
  [AuthFlowType.EMAIL_LOGIN]: {
    form: "verify_PIN__" + AuthFlowType.EMAIL_LOGIN,
    flow: AuthFlowType.EMAIL_LOGIN,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "pin_validation.header_title",
      headerSubtitle: "pin_validation.header_message",
      nextButton: 'pin_validation.button_next_message',
      input: {
        text: "pin_validation.pin_input",
        aria: "accessibility.email.registration.verify_pin.input"
      }
    },
    identifierField: 'phoneNumber',
  }
};